module.exports = __webpack_public_path__ + "img/steam.57021107.svg";